import { render } from "./TileSelectable.vue?vue&type=template&id=45694f21&ts=true"
import script from "./TileSelectable.ts?vue&type=script&lang=ts"
export * from "./TileSelectable.ts?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__